import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.13.2_@swc+helpers@0.5.23_next@15.5.28_@types+node@20.19.43_babel-plugin-mac_b71b92cc981527d36403bf9e0802b4c3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.13.2_@swc+helpers@0.5.23_next@15.5.28_@types+node@20.19.43_babel-plugin-mac_b71b92cc981527d36403bf9e0802b4c3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@types+node@20.19.43_babel-plugin-macros@3.1.0_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.101.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@types+node@20.19.43_babel-plugin-macros@3.1.0_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.101.3/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@types+node@20.19.43_babel-plugin-macros@3.1.0_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.101.3/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/link.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/molecules/Heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AchievedGrid"] */ "/app/src/components/organisms/AchievedGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/Breadcrumb/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselModule"] */ "/app/src/components/organisms/CarouselModule/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/Faq/FaqList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Glossary"] */ "/app/src/components/organisms/Glossary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GolsGrid"] */ "/app/src/components/organisms/GolsGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/HelpText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/HeroBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/IframeTabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/ImageBannerBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandRegistrationGuide"] */ "/app/src/components/organisms/LandRegistrationGuide/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModuleMap"] */ "/app/src/components/organisms/ModuleMap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/ModuloInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/ModuloTexto/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitularInfo"] */ "/app/src/components/organisms/ModuloTitularInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/NewsBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/app/src/components/organisms/Newsletter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CaseNotFoundBlock"] */ "/app/src/components/organisms/pb-sections/CaseNotFoundBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DigitalChannelsBlock"] */ "/app/src/components/organisms/pb-sections/DigitalChannelsBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/pb-sections/FaqsBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/pb-sections/InfoAccordionWithImageBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoListWithImageBlock"] */ "/app/src/components/organisms/pb-sections/InfoListWithImageBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoTextListBlockContent"] */ "/app/src/components/organisms/pb-sections/InfoTextListBlockContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/pb-sections/InfoTextWithMapBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MunicipalityServicesBlock"] */ "/app/src/components/organisms/pb-sections/MunicipalityServicesBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/pb-sections/RelatedPagesBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StepsAccordionSection"] */ "/app/src/components/organisms/pb-sections/StepsAccordionSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonyBlockContent"] */ "/app/src/components/organisms/pb-sections/TestimonyBlockContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatForBlock"] */ "/app/src/components/organisms/pb-sections/WhatForBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/Post/PostList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProcessFlow"] */ "/app/src/components/organisms/ProcessFlow/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicationCardsContent"] */ "/app/src/components/organisms/PublicationCards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/PublicationCards/PublicationsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultGrid"] */ "/app/src/components/organisms/ResultGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/ServiceCountList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/Timeline/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoCard"] */ "/app/src/components/organisms/Video/VideoCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/page-builder/errors/FragmentNotRegisteredError.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/page-builder/fragments/FormBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/page-builder/fragments/HeadlineBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/page-builder/fragments/InfoTextWithVideoBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/page-builder/fragments/StatsPowerBiBlock/index.tsx");
